import { useTranslation } from "react-i18next";

const STYLES = {
  brouillon: "bg-stone-200 text-stone-700 border-stone-300",
  envoye: "bg-[#FCEFD9] text-[#8A5A0F] border-[#F6D9A9]",
  envoyee: "bg-[#FCEFD9] text-[#8A5A0F] border-[#F6D9A9]",
  a_envoyer: "bg-[#E3EDF7] text-[#1F4E79] border-[#BFD7EE]",
  accepte: "bg-[#E4F2E7] text-[#276440] border-[#B8E2C2]",
  payee: "bg-[#E4F2E7] text-[#276440] border-[#B8E2C2]",
  refuse: "bg-[#FBE4E1] text-[#A32E20] border-[#F5C2BC]",
  en_retard: "bg-[#FBE4E1] text-[#A32E20] border-[#F5C2BC]",
};

export default function StatutBadge({ statut, envoyeeLe, testid }) {
  const { t } = useTranslation();
  // facture validée (numéro figé) mais jamais réellement envoyée au client
  const cle = statut === "envoyee" && !envoyeeLe ? "validee" : statut;
  return (
    <span data-testid={testid}
          className={`border text-xs sm:text-sm font-semibold px-3 py-1 rounded-full inline-flex items-center gap-1.5 whitespace-nowrap ${STYLES[statut] || STYLES.brouillon}`}>
      {t(`statuts.${cle}`, statut)}
    </span>
  );
}
